import React from 'react';
import { Link } from 'react-router-dom';
import './NotFound.scss';
import logo from '../images/FWC-Logo.svg';

const NotFound = () => {
  return (
    <div className="not-found-container">
      <div className="not-found-content">
        <img src={logo} alt="FWC Logo" className="company-logo" />
        <h1>404</h1>
        <h2>Page Not Found</h2>
        <p>Oops! The page you're looking for doesn't exist or has been moved.</p>
        <Link to="/" className="home-button">
          Return to Home
        </Link>
      </div>
    </div>
  );
};

export default NotFound; 